import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

const MiniCartSidebar = () => {
  const { cart, getCartTotal, getCartCount, updateQuantity } = useCart();

  const hasItems = cart.length > 0;

  if (!hasItems) {
    return null;
  }

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="fixed top-16 right-0 h-[calc(100vh-4rem)] w-64 bg-white shadow-2xl z-50 border-l border-gray-200 hidden md:flex flex-col">
        {/* Cart Items */}
        <div className="flex-1 overflow-y-auto p-3">
          <h3 className="font-bold text-sm mb-3 text-gray-800">
            Cart ({getCartCount()})
          </h3>
          <div className="space-y-3">
            {cart.map((item) => (
              <div
                key={`${item.id}-${item.variant.size}`}
                className="bg-gray-50 p-2 rounded-lg"
              >
                <div className="flex gap-2 mb-2">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-14 h-14 object-cover rounded"
                  />
                  <div className="flex-1 min-w-0">
                    <h4 className="text-xs font-semibold text-gray-800 truncate">
                      {item.name}
                    </h4>
                    <p className="text-xs text-gray-600">{item.variant.size}</p>
                    <p className="text-xs text-green-600 font-bold">
                      ₹{item.variant.offerPrice}
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <div className="flex items-center border-2 border-green-500 rounded-full overflow-hidden">
                    <button
                      onClick={() =>
                        updateQuantity(
                          item.id,
                          item.variant.size,
                          item.quantity - 1
                        )
                      }
                      className="px-3 py-1 hover:bg-green-50 transition"
                      title={item.quantity === 1 ? "Remove" : "Decrease"}
                    >
                      {item.quantity === 1 ? (
                        <svg
                          className="w-3 h-3 text-gray-700"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          />
                        </svg>
                      ) : (
                        <span className="text-sm font-bold text-gray-700">
                          −
                        </span>
                      )}
                    </button>
                    <span className="text-xs font-bold px-3 text-gray-800">
                      {item.quantity}
                    </span>
                    <button
                      onClick={() =>
                        updateQuantity(
                          item.id,
                          item.variant.size,
                          item.quantity + 1
                        )
                      }
                      className="px-3 py-1 hover:bg-green-50 transition"
                    >
                      <span className="text-sm font-bold text-gray-700">+</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="border-t p-3 bg-gray-50">
          <div className="space-y-1 mb-3">
            <div className="flex justify-between text-xs">
              <span className="text-gray-600">Total</span>
              <span className="font-bold text-green-600">
                ₹{getCartTotal()}
              </span>
            </div>
          </div>
          <Link
            to="/cart"
            className="block w-full bg-green-500 text-white text-center py-2 rounded-lg text-xs font-semibold hover:bg-green-600 transition"
          >
            View Cart
          </Link>
        </div>
      </div>

      {/* Mobile Floating Button */}
      <Link
        to="/cart"
        className="md:hidden fixed bottom-20 right-4 bg-green-500 text-white p-4 rounded-full shadow-2xl z-50"
      >
        <div className="relative">
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
            {getCartCount()}
          </span>
        </div>
      </Link>
    </>
  );
};

export default MiniCartSidebar;
